import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "../../lib/content";
import { QUOTE_PATH } from "../../lib/site";

const ServiceCard = ({ s, i }) => {
  const Icon = s.icon;
  return (
    <Reveal delay={(i % 3) * 0.08} className="h-full">
      <article data-testid={`service-card-${i}`} className="group relative flex h-full flex-col rounded-[1.75rem] border border-forest/10 bg-white p-7 transition-[box-shadow,border-color] duration-500 hover:border-forest/25 hover:shadow-[0_30px_60px_-30px_rgba(10,46,32,0.35)] sm:p-8">
        <div className="flex items-start justify-between">
          <span className="grid h-14 w-14 place-items-center rounded-2xl bg-solar text-white transition-transform duration-500 group-hover:-rotate-6"><Icon className="h-6 w-6" strokeWidth={1.6} /></span>
          <span className="font-display text-sm text-ink/50">0{i + 1}</span>
        </div>
        {s.onRequest && <span className="mt-6 inline-flex w-fit rounded-full border border-gold bg-gold/15 px-3 py-1 text-xs font-medium text-[#7a4f00]" data-testid={`service-on-request-${i}`}>Sob consulta</span>}
        <h3 className={`${s.onRequest ? "mt-3" : "mt-6"} font-display text-2xl font-medium leading-tight tracking-tight text-forest`}>{s.title}</h3>
        <p className="mt-3 text-[15px] leading-relaxed text-ink/75">{s.text}</p>
        <ul className="mt-5 space-y-2">
          {s.benefits.map((b) => (
            <li key={b} className="flex items-start gap-2 text-sm text-ink/80"><Check className="mt-0.5 h-4 w-4 shrink-0 text-leaf-ink" />{b}</li>
          ))}
        </ul>
        <Link to={s.to || QUOTE_PATH} data-testid={`service-cta-${i}`} className="mt-auto inline-flex items-center gap-2 pt-8 text-sm font-medium text-forest hover:text-[#7a4f00] transition-colors">
          {s.cta} <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </article>
    </Reveal>
  );
};

export const ServicesGrid = () => (
  <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
    {SERVICES.map((s, i) => <ServiceCard key={s.title} s={s} i={i} />)}
  </div>
);
